import * as ActionTypes from 'src/constants/ActionTypes';
import { IStateLocation } from 'src/entity/StateEntity';

const initialState: IStateLocation = {
  reload: true,
  locations: [],
  isFetching: false,
  type: ActionTypes.PROVINCE_STATUS_RELOAD,
};

export const locationState = (state: IStateLocation = initialState, action: IStateLocation): IStateLocation => {
  switch (action.type) {
    case ActionTypes.PROVINCE_STATUS_RELOAD:
      return Object.assign({}, state, {
        type: action.type,
        reload: true,
        isFetching: false,
        locations: [],
      });
    case ActionTypes.PROVINCE_STATUS_REQUEST:
      return Object.assign({}, state, {
        type: action.type,
        reload: false,
        isFetching: true,
        locations: action.locations || [],
      });
    case ActionTypes.PROVINCE_STATUS_SUCCESS:
      return Object.assign({}, state, {
        type: action.type,
        reload: false,
        isFetching: false,
        locations: action.locations || [],
      });
    case ActionTypes.PROVINCE_STATUS_FAILURE:
      return Object.assign({}, state, {
        type: action.type,
        reload: true,
        isFetching: false,
        locations: [],
      });
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/locationState.ts